import ContextMenu from "core/components/contextMenu/contextMenu";
import LeftMenuLink from "./leftMenuLink";
import { MenuLinkModel } from "../shared/MenuLinkProps";
import useScreenResolution from "core/hooks/useScreenResolution";
import {EmblaIcons} from "../../emblaIcons";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {RoutePaths} from "../../../infrastructure/routes";
import {LeftMenuExternalLink} from "./leftMenuExternalLink";

export type DynamicMenuProps = {
    menuLinks: Array<MenuLinkModel>;
    showNotifications?: boolean;
}

export function DynamicMenu({menuLinks, showNotifications}: DynamicMenuProps) {

    const { isMobile } = useScreenResolution();

    const MaxAmountBeforeContextMenu = 4;
    const MaxToShowInBottomMenu = MaxAmountBeforeContextMenu - 1;

    const hjaelpMenu = new MenuLinkModel({
        emblaIconName: EmblaIcons.Question,
        linkText: Localizer.global_hjaelp(),
        routePath: RoutePaths.Hjaelp.url
    }, false);

    return (
        <>
            {!isMobile &&
                <>
                    {menuLinks.map((e, i) => {
                        return (
                            <LeftMenuLink
                                key={e.MenuLinkProps.linkText + i}
                                emblaIconName={e.MenuLinkProps.emblaIconName}
                                linkText={e.MenuLinkProps.linkText}
                                routePath={e.MenuLinkProps.routePath}
                                routePathsToHighlight={e.MenuLinkProps.routePathsToHighlight ?? [e.MenuLinkProps.routePath]}
                                showNotification={showNotifications && e.MenuLinkProps.enableShowNotification && e.MenuLinkProps.showNotification}
                                showNotificationAmount={e.MenuLinkProps.showNotificationAmount}
                                linkState={e.MenuLinkProps.linkState}
                            />
                        )
                    })}
                    {/*Hjaelp er global for alle brugere*/}
                    <LeftMenuExternalLink
                        key={hjaelpMenu.MenuLinkProps.linkText}
                        emblaIconName={hjaelpMenu.MenuLinkProps.emblaIconName}
                        linkText={hjaelpMenu.MenuLinkProps.linkText}
                        routePath={hjaelpMenu.MenuLinkProps.routePath}
                    />
                </>
            }

            {isMobile &&
                <div className={"flex-container"}>
                    {(menuLinks.length <= MaxAmountBeforeContextMenu ? menuLinks : menuLinks.slice(0, MaxToShowInBottomMenu)).map(e =>
                        <LeftMenuLink
                            emblaIconName={e.MenuLinkProps.emblaIconName}
                            linkText={e.MenuLinkProps.linkText}
                            routePath={e.MenuLinkProps.routePath}
                            routePathsToHighlight={e.MenuLinkProps.routePathsToHighlight ?? [e.MenuLinkProps.routePath]}
                            showNotification={showNotifications && e.MenuLinkProps.enableShowNotification && e.MenuLinkProps.showNotification}
                            showNotificationAmount={e.MenuLinkProps.showNotificationAmount}
                            linkState={e.MenuLinkProps.linkState}
                            disabled={!e.ClickableOnMobile}
                        />
                    )}

                    {menuLinks.length > MaxAmountBeforeContextMenu &&
                        <div className={"padding-right-s bottom-menu-contex-menu-wrapper"}>
                            <ContextMenu border={true} additionalChildrenWrapperClasses="dropdown-menu-padding-0">
                                {menuLinks.slice(MaxToShowInBottomMenu, menuLinks.length).map((e, i) =>
                                    <ContextMenu.Item
                                        key={i}
                                        emblaIconName={e.MenuLinkProps.emblaIconName}
                                        text={e.MenuLinkProps.linkText}
                                        linkRoutePath={e.MenuLinkProps.routePath}
                                        shouldRender={e.ShouldRender ? e.ShouldRender() : undefined}
                                        showNotification={showNotifications && e.MenuLinkProps.enableShowNotification && e.MenuLinkProps.showNotification}
                                        showNotificationAmount={e.MenuLinkProps.showNotificationAmount}
                                        clickableOnMobile={e.ClickableOnMobile}
                                    />
                                )}
                                <ContextMenu.Item
                                    externalLink
                                    key={hjaelpMenu.MenuLinkProps.linkText}
                                    emblaIconName={hjaelpMenu.MenuLinkProps.emblaIconName}
                                    text={hjaelpMenu.MenuLinkProps.linkText}
                                    linkRoutePath={hjaelpMenu.MenuLinkProps.routePath}
                                    clickableOnMobile={true}
                                />
                            </ContextMenu>
                        </div>
                    }
                </div>
            }
        </>
    );
}
